import React, { useState, useEffect } from 'react';
import '../output.css';
import '@fortawesome/fontawesome-free/css/all.css';
import { useAppContext } from '../appContext';
import { getOrgQuestions, adminModifyOrgQuestions, adminGetMembers, adminGetMemberInfo, adminGetOrgInfo, uploadPersonalInfo, adminInviteMembers, adminDeleteUnusedMembers, adminRemindMembers } from '../api';
import { generateGUID, GetFriendlyOrgNames } from '../utils/utils'
// import AdminCustomQuestionScreen from '../adminCustomQs';
// import AdminQuestionModal from '../AdminQuestionModal';
import LoadingOverlay from './loadingOverlay';
import InfoModal from './infoModal';
import HistoryScreen from './HistoryScreen';
import EndScreenModal from './endScreenModal';
import AdminOrgTrend from './AdminOrgTrend';
import { Member, OrgQuestion, InterviewObject, AnsweredQuestions, OrgQuestions, OrganizationInfo, Cohort, MemberInfo, SessionQuestion, Question } from '@/utils/types';
import Nav from './nav';
import { isAdmin } from "../utils/utils"
import campus from '../../TDD-Images/banners/campus.png'
import ReportsScreen from './reportsScreen';
import AdminSettings from './AdminSettings';
import MembersScreen from './membersScreen';

export default function Admin() {
    const { state, reducers } = useAppContext();
    const { setmemberFeedbackModal, setquestionModal, setoverlayComp } = reducers;
    const [cohorts, setcohorts] = useState<Cohort[]>([]);
    const [orgInfo, setOrgInfo] = useState<OrganizationInfo | undefined | null>(undefined);
    const [isError, setisError] = useState<boolean>(false);
    const [showMembers, setShowMembers] = useState(false);
    const [showQOps, setShowQOps] = useState(false);
    const [selectedMember, setSelectedMember] = useState<Member|null>(null);
    const [selectedMemberInfo, setSelectedMemberInfo] = useState<MemberInfo|null>(null);
    const [currScreen, setCurrScreen] = useState("DASHBOARD");
    const [questions, setQuestions] = useState<{ [key: string]: OrgQuestion[] }>({});
    const [loadingOverlay, setLoadingOverlay] = useState(false);
    const [category, setCategory] = useState("");
    const [image2, setimage2] = useState(null);

    const EditQuestion = async (index: number, newq: string, rubric: string | null = null) => {
        setoverlayComp(<LoadingOverlay loadingOverlay={true} />);
        EditQuestionAsync(index, newq, rubric);
    }

    const inviteMembers = async (members: Member[]) => {
        const newCohorts = await adminInviteMembers(members);
        if (newCohorts) {
            setcohorts(newCohorts);
            setisError(false);
        }
        else {
            setisError(true);
        }
    }

    const deleteMembers = async (members: Member[]) => {
        const newCohorts = await adminDeleteUnusedMembers(members);
        if (newCohorts) {
            setcohorts(newCohorts);
            setisError(false);
        }
        else {
            setisError(true);
        }
    }

    const EditQuestionAsync = async (index: number, newq: string, rubric: string | null = null) => {
        if (questions[category]) {
            questions[category][index] = { question: newq, rubric: rubric };
            const newqs: { [key: string]: OrgQuestion[] } = await adminModifyOrgQuestions(category, questions[category]) || {};
            setQuestions(newqs);
            setoverlayComp(null);
            setquestionModal(null);
        }
    }

    const AddQuestion = async (newq: string, rubric: string | null = null) => {
        setoverlayComp(<LoadingOverlay loadingOverlay={true} />);
        AddQuestionAsync(newq, rubric);
    }

    const AddQuestionAsync = async (newq: string, rubric: string | null = null) => {
        if (questions[category] === undefined) {
            questions[category] = [];
        }
        questions[category].push({ question: newq, rubric: rubric });
        const newqs: { [key: string]: OrgQuestion[] } = await adminModifyOrgQuestions(category, questions[category]) || {};
        setQuestions(newqs);
        setoverlayComp(null);
        setquestionModal(null);
    }

    const AddQuestions = async (array: [string, string | null][]) => {
        setoverlayComp(<LoadingOverlay loadingOverlay={true} />);
        AddQuestionsAsync(array);
    }

    const AddQuestionsAsync = async (array: [string, string | null][]) => {
        if (questions[category] === undefined) {
            questions[category] = [];
        }
        for (let i = 0; i < array.length; i++) {
            let item = array[i];
            questions[category].push({ question: item[0], rubric: item[1] });
        }
        const newqs: { [key: string]: OrgQuestion[] } = await adminModifyOrgQuestions(category, questions[category]) || {};
        setQuestions(newqs);
        setoverlayComp(null);
        setquestionModal(null);
    }

    const DeleteQuestion = async (index: number) => {
        setoverlayComp(<LoadingOverlay loadingOverlay={true} />);
        DeleteQuestionAsync(index);
    }

    const DeleteQuestionAsync = async (index: number) => {
        if (questions[category]) {
            questions[category].splice(index, 1);
            const newqs: { [key: string]: OrgQuestion[] } = await adminModifyOrgQuestions(category, questions[category]) || {};
            setQuestions(newqs);
            setoverlayComp(null);
        }
    }

    // const setqMod = () => {
    //     setquestionModal(
    //         <AdminQuestionModal
    //             showQuestionMod={true}
    //             toggleQuestionModal={() => setquestionModal(null)}
    //             question={''}
    //             rubric={''}
    //             selectedInd={-1}
    //             EditQuestion={(v, e, r) => EditQuestion(v, e, r)}
    //             AddQuestion={(v, e) => AddQuestion(v, e)}
    //             AddQuestions={(array) => AddQuestions(array)}
    //             setcategory={(e) => setCategory(e)}
    //             category={category}
    //         />
    //     );
    // }

    const updateProfileInfo = async (name: string, role: string) => {
        const user = await uploadPersonalInfo(name, role);
        reducers.setprofileUser(user);
    }

    const AttemptedQuestionSelected = (question: string, i: number | null = null) => {
        let q = selectedMemberInfo?.answeredQuestions[question];
        if (q) {
            let ind = i === null ? q.length - 1 : i;
            let info = q[ind];
            let session : SessionQuestion[] = [
                {
                  question: {
                    question: question,
                    level: null,
                    domain: info["domain"]||"",
                    type: "",
                    specType: info["specType"]||"",
                    subCategories: []
                  } as Question,
                  role: info["role"],
                  feedback: info["feedback"],
                  actionsteps: info["actionSteps"] ? info["actionSteps"] : "",
                  prompt: info["transcript"],
                  fullprompt: [],
                  samplesolution: info["samplesolution"] ? info["samplesolution"] : "",
                  code: info["whiteboard"] ? info["whiteboard"] : "",
                  useWhiteboard:
                    info["whiteboard"] && info["whiteboard"] !== ""
                      ? true
                      : state.useWhiteboard,
                  codingLang: info["codingLang"] ? info["codingLang"] : "",
                  time: info["interviewDuration"] ? info["interviewDuration"] : -1,
                  isHelpful: null,
                  isHelpfulMessage: null,
                  feedbackDuration: 0,
                  sessionId: "",
                }];

                reducers.setsession(session);
                reducers.setpastInfo({...info, index: ind});
                reducers.setshowFeedback(true);
                reducers.setshowHistoryModal(false);
                reducers.setdisplayPastFeedback(true);
                reducers.setretryPast(false);
                reducers.setloading(false);
                reducers.setcurrentQuestion(0);
                    

            setmemberFeedbackModal(
                <EndScreenModal
                    showFeedback={true}
                    toggleFeedbackModal={() => setmemberFeedbackModal(null)}
                />
            );
        }
    }

    useEffect(() => {
        if (state.profileUser) {
            const fetchData = async () => {
                try{
                    const image3 = await import(`../../TDD-Images/banners/${state.profileUser?.organization}.png`);
                    setimage2(image3.default);
                }
                catch{

                }
                const orgInfo1 = await adminGetOrgInfo() || null;
                setOrgInfo(orgInfo1);
                if (orgInfo1) {
                    const cohorts = await adminGetMembers() || [];
                    setcohorts(cohorts);
                }
                // const mem = await adminGetMembers() || [];
                // //const q = await getOrgQuestions() || {};
                // //setQuestions(q);
                // setMembers(mem);
                // const promises = mem?.map(m => adminGetMemberInfo(m.email));
                // const responses = await Promise.all(promises);
                // let obj: { [key: string]: AnsweredQuestions } = {};
                // for (let i = 0; i < mem.length; i++) {
                //     obj[mem[i].email] = responses[i]??{};
                // }
                // setMembersInfo(obj);
            };
            fetchData();
        }
    }, [state.profileUser]);

    useEffect(() => {
        if(selectedMember!== null){
            setoverlayComp(<LoadingOverlay loadingOverlay={true} />);
        }
        const fetchData = async () => {
            if (selectedMember != null) {
                adminGetMemberInfo(selectedMember.email)
                .then(result=>{
                    setSelectedMemberInfo(result);
                    setoverlayComp(null);
                    if(result !== null)
                    {
                        setCurrScreen("MEMBER");
                        setCategory("");
                    }
                });
            }
        }
        fetchData();
    }, [selectedMember]);

    // useEffect(() => {
    //     if (category !== "") {
    //         setCurrScreen("CUSTOMQUESTIONS");
    //         setSelectedMember(-1);
    //     }
    //     if (state.questionModal !== null) {
    //         setqMod();
    //     }
    // }, [category]);

    useEffect(() => {
        if (currScreen === "DASHBOARD") {
            // setSelectedMember(-1);
            // setCategory("");
        }
    }, [currScreen]);

    return (
        <>
            <Nav />
            {!state.profileUser &&
                <p className='mt-5'>Sign in with admin account to get access</p>
            }
            {state.profileUser && !(isAdmin(state.profileUser)) && <p className='mt-5'>You do not have admin access</p>}

            {state.profileUser && isAdmin(state.profileUser) &&
                <div className='full-nav'>
                    {currScreen === "DASHBOARD" && <div className="w-screen h-[25vh]"> <img src={image2??campus} className='object-cover w-full h-full' /></div>}
                    <div className="adminScreen">
                        <div id="scrollingDiv" className={`adminSidebar`}>
                            <div className='adminMenu'>
                                <div onClick={() => setCurrScreen("DASHBOARD")} className={`menuitem ${currScreen === "DASHBOARD" ? 'selected' : ''}`}>
                                    <p>Dashboard</p>
                                </div>
                                <div onClick={() => setCurrScreen("MEMBERS")} className={`menuitem ${currScreen === "MEMBERS" || currScreen === "MEMBER" ? 'selected' : ''}`}>
                                    <p>Members</p>
                                </div>

                                <div onClick={() => setCurrScreen("SETTINGS")} className={`menuitem ${currScreen === "SETTINGS" ? 'selected' : ''}`}>
                                    <p>Settings</p>
                                </div>
                                
                                <div onClick={() => setCurrScreen("REPORTS")} className={`menuitem ${currScreen === "REPORTS" ? 'selected' : ''}`}>
                                    <p>Reports</p>
                                </div>
                            </div>
                        </div>
                        <div className="adminContent mt-[8vh]">
                            {currScreen === "DASHBOARD" &&
                                <div className="w-[90%]">
                                    <AdminOrgTrend
                                        orgInfo={orgInfo}
                                        cohorts={cohorts}
                                        admin={state.profileUser}
                                        navigateToMembers={() => setCurrScreen("MEMBERS")}
                                    />
                                </div>
                                // <AdminOrgTrend
                                //     organization={GetFriendlyOrgNames(state.profileUser)}
                                //     membersInfo={membersInfo}
                                // />
                            }
                            {currScreen === "MEMBERS" &&
                                <div className="w-[90%]">
                                    <MembersScreen cohorts={cohorts}
                                        inviteMembers={(members: Member[]) => inviteMembers(members)}
                                        deleteMembers={(members: Member[]) => deleteMembers(members)}
                                        remindMembers={(members: Member[]) => adminRemindMembers(members)}
                                        memberSelected={(member:Member|null)=>setSelectedMember(member)}
                                        error={isError}
                                        setoverlayComp={(val: boolean) => setoverlayComp(val ? <LoadingOverlay loadingOverlay={true} /> : null)}
                                        setResultOverlayComp={(text: string | null) => setoverlayComp(text ? <InfoModal showInfoMessage={true} text={text} /> : null)}
                                    />
                                </div>

                            }
                            {currScreen === "SETTINGS" &&
                                <div className="w-[90%]">
                                    <AdminSettings
                                        orgInfo={orgInfo}
                                        cohort={cohorts.filter(x => x.id == orgInfo?.currentCohort).at(0)}
                                        admin={state.profileUser}
                                        updateProfileInfo={(name, role) => updateProfileInfo(name, role)}
                                        setoverlayComp={(val: boolean) => setoverlayComp(val ? <LoadingOverlay loadingOverlay={true} /> : null)}
                                    />
                                </div>

                            }
                            {currScreen === "MEMBER" &&
                                <HistoryScreen
                                adminViewInfo={
                                    {
                                        studentInfo:selectedMemberInfo!,
                                        studentName: selectedMember!.name,
                                        goToMembers:()=>{setCurrScreen("MEMBERS");setmemberFeedbackModal(null);setSelectedMember(null)}
                                    }
                                }
                                    AttemptedQuestionSelected={(e, i) => AttemptedQuestionSelected(e, i)}
                                />
                            }
                            {currScreen === "REPORTS" &&
                                <div className="w-[90%]">
                                    <ReportsScreen cohorts={cohorts}
                                        error={isError}
                                        setoverlayComp={(val: boolean) => setoverlayComp(val ? <LoadingOverlay loadingOverlay={true} /> : null)}
                                        setResultOverlayComp={(text: string | null) => setoverlayComp(text ? <InfoModal showInfoMessage={true} text={text} /> : null)}
                                    />
                                </div>

                            }

                            {/* {currScreen === "CUSTOMQUESTIONS" &&
                                <AdminCustomQuestionScreen
                                    setquestionModal={(e) => setquestionModal(e)}
                                    setloadingOverlay={(v) => setoverlayComp(v)}
                                    questions={category !== "" && questions.hasOwnProperty(category) ? questions[category] : []}
                                    EditQuestion={(index, newq, rubric) => EditQuestion(index, newq, rubric)}
                                    DeleteQuestion={(newq) => DeleteQuestion(newq)}
                                    AddQuestion={(newq, rubric) => AddQuestion(newq, rubric)}
                                    AddQuestions={(arr) => AddQuestions(arr)}
                                    category={category}
                                    setcategory={(e) => setCategory(e)}
                                />
                            } */}
                        </div>
                    </div>
                </div>}
        </>
    );
}
